import React, { FC } from "react";
import { Gpm as GpmDataType, GpmType, GpmThreshold } from "../../data-types";
import { Gpm } from "../matter-editor/gpm";
import { GpmSlider } from "../gpm-slider";
import { useGpmSettingsCheck } from "~/hooks";

export type GpmOrSliderProps = {
  gpm: GpmDataType | number;
  gpmThreshold: GpmThreshold | null;
  isFeeEarnerLevelGpm: boolean;
  showRequired?: boolean;
  showGpm?: boolean;
  showGpmSlider?: boolean;
  gpmStyle?: React.CSSProperties;
  gpmSliderStyle?: React.CSSProperties;
  gpmSliderClassName?: string;
};

export const GpmOrSlider: FC<GpmOrSliderProps> = ({
  gpm,
  gpmThreshold,
  isFeeEarnerLevelGpm,
  showRequired,
  showGpm,
  showGpmSlider,
  gpmStyle,
  gpmSliderStyle,
  gpmSliderClassName,
}) => {
  let showGpmVal = showGpm;
  let showGpmSliderVal = showGpmSlider;
  if (showGpm === undefined || showGpmSlider === undefined) {
    const settings = useGpmSettingsCheck();
    showGpmVal = showGpmVal === undefined ? settings.showGpm : showGpmVal;
    showGpmSliderVal = showGpmSliderVal === undefined ? settings.showGpmSlider : showGpmSliderVal;
  }

  const gpmVal = typeof gpm === "number" ? { gpm: gpm, type: GpmType.Fixed } : gpm;

  return showGpmVal ? (
    <div style={gpmStyle}>
      <Gpm
        isFeeEarnerLevelGpm={isFeeEarnerLevelGpm}
        gpm={gpmVal as GpmDataType}
        gpmThreshold={gpmThreshold}
        showRequired={showRequired}
      />
    </div>
  ) : showGpmSliderVal &&
    gpmThreshold &&
    gpmThreshold.gpmDangerThreshold &&
    gpmThreshold.gpmWarningThreshold ? (
    <div style={gpmSliderStyle} className={gpmSliderClassName}>
      <GpmSlider
        showGpm={showGpmVal ?? false}
        gpmThreshold={gpmThreshold}
        gpm={gpm}
        isFeeEarnerLevelGpm={isFeeEarnerLevelGpm}
        totalWidth={typeof gpmSliderStyle?.width === "number" ? gpmSliderStyle.width : undefined}
      />
    </div>
  ) : null;
};
